<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Payment-Policy-Create",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
